var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M24 48C10.7452 48 0 37.2548 0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48Z","fill":"#231F20","key":0}),React.createElement("rect",{"x":"-0.201389","y":"0.201389","width":"28.5972","height":"0.402778","transform":"matrix(-1 0 0 1 39.5972 23.1812)","stroke":"white","strokeWidth":"0.402778","key":1}),React.createElement("path",{"d":"M21.0862 13L11 23.5839L21.0862 34.5354","stroke":"white","key":2})]);
}

ArrowLeft.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
